import AWS from 'aws-sdk';

const configureS3Client = () => {
  AWS.config.update({
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_ACCESSKEYID_AWS,
    secretAccessKey: process.env.REACT_APP_ACCESSKEYSECRET_AWS,
  });
  return new AWS.S3();
};

export const awsSearchObjects = async ({ query, limit = 200, maxPages = 200, onProgress } = {}) => {
  const s3 = configureS3Client();
  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET,
    Prefix: process.env.REACT_APP_AWS_PREFIX,
    MaxKeys: 1000,
  };

  const results = [];
  let pages = 0;
  let marker;
  if (typeof onProgress === 'function') onProgress(0);

  while (pages < maxPages && results.length < limit) {
    if (marker) params.Marker = marker;
    // eslint-disable-next-line no-await-in-loop
    const response = await s3.listObjects(params).promise();
    const contents = response.Contents || [];
    const matches = contents.filter((it) => String(it.Key).toLowerCase().includes(String(query).toLowerCase()));
    results.push(...matches);
    pages += 1;
    if (typeof onProgress === 'function') {
      const pct = Math.min(0.95, pages / maxPages);
      onProgress(pct);
    }
    if (!response.IsTruncated) break;
    marker = contents.slice(-1)[0]?.Key;
  }

  if (typeof onProgress === 'function') onProgress(1);
  return { items: results.slice(0, limit), pagesScanned: pages };
};

export default awsSearchObjects;


